import { ListItem, tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const SheetContainer = styled.div`
  @media (max-width: ${tokens.breakpoints.desktop}px) {
    && [class*='Modalstyles__ModalWrapper'] {
      max-height: calc(
        100dvh - var(--mobile-footer-height, 56px) - 24px
      ) !important;
    }
  }
`

export const ListItemPointer = styled(ListItem)`
  cursor: pointer;
  border-color: ${tokens.colors.dark1};
`

export const ListItemDisabled = styled(ListItem)`
  cursor: not-allowed;
  border-color: ${tokens.colors.dark1};
`

export const ListItemBox = styled.div`
  > :last-child {
    border-bottom: none;
  }
`
